import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

import CustomModal from "../CustomModal";
import { showToast } from "../../../utils/helper";

const AcceptBookingModal = ({ show, request, onClose, onConfirm, saving }) => {
  const initialAmount =
    request && (request.offeredAmount || request.grossAmount || "");
  const [amount, setAmount] = useState(initialAmount);

  const handleConfirm = () => {
    const value = parseFloat(amount);
    if (!amount || isNaN(value) || value <= 0) {
      showToast("error", "Enter a valid amount greater than 0");
      return;
    }
    onConfirm(value);
  };

  return (
    <CustomModal show={show} title="Accept Booking" onClose={onClose}>
      <p className="text-muted mb-3">
        {request && request.spot && request.spot.name
          ? `Set the final price for the booking at "${request.spot.name}".`
          : "Set the final price for this booking."}
      </p>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold">Amount</Form.Label>
        <div className="input-group">
          <span className="input-group-text">$</span>
          <Form.Control
            type="number"
            min="0"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Amount"
          />
        </div>
        <Form.Text className="text-muted">
          Pre-filled with the client's offered amount. Edit it if you want to
          accept at a different price.
        </Form.Text>
      </Form.Group>

      <div className="d-flex gap-2">
        <Button
          variant="outline-secondary"
          className="flex-fill"
          onClick={onClose}
          disabled={saving}
        >
          <span>Cancel</span>
        </Button>
        <Button
          variant=""
          className="new-vehicle-submit flex-fill"
          onClick={handleConfirm}
          disabled={saving}
        >
          <span>
            {saving && <i className="fas fa-spin fa-spinner me-2" />}
            Accept
          </span>
        </Button>
      </div>
    </CustomModal>
  );
};

export default AcceptBookingModal;
